import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthenticationService} from '../services/authentication.service';
import {NotificationService} from '../notification/notification.service';
import {NotificationType} from '../enum/notification-type.enum';

@Injectable({
  providedIn:'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router:Router,
    private authenticationService: AuthenticationService,
    private notification: NotificationService

  ) {
  }

  /**
   * Determines if the user is authorized to access the requested route
   *
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {boolean}
   * @memberof AuthenticationGuard
   */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.isUserLoggedIn();
  }

  /**
   * Determines if the user is logged in
   *
   * @private
   * @returns {boolean}
   * @memberof AuthenticationGuard
   */
  private isUserLoggedIn(): boolean {
    const isLoggedIn = this.authenticationService.isLogin();
    if (!isLoggedIn) {
      this.router.navigate(['/auth/login']).then(() => {
        // Navigated successfully. Do something here.
        this.notification.notify(NotificationType.WARNING, "Vous devez vous connecter pour accéder à cette page",'')
        console.log("Navigated to login page.");
      }).catch(error => {
        // Navigation failed. Handle the error here.
        /*this.notification.notify(NotificationType.ERROR, error.toString(),"")*/
        console.log("Navigation failed. Error: ", error);
      });
    }
    return isLoggedIn;
  }
}
